import { EmptyState, Flex, InfoBox, LoadingIndicator } from "@jsq/ds/core";
import { withClientContext } from "~/apollo/client";
import { useGetHistoricalDdqAnswersQuery } from "~/graphql/supergraphHooks";
import { QaEntryRow } from "./QaEntryRow";

export type HistoricalAnswersProps = {
  arenaId: number;
  uploadId: string;
};

export const HistoricalAnswers = ({ arenaId, uploadId }: HistoricalAnswersProps) => {
  const { data, loading, error } = useGetHistoricalDdqAnswersQuery({
    context: withClientContext("federation"),
    variables: { arenaId, uploadId },
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  if (loading && !data) {
    return (
      <Flex justifyContent="center" data-testid="historical-answers-loading">
        <LoadingIndicator size="large" />
      </Flex>
    );
  }

  // errorPolicy "all" can hand back an error alongside data; only a total failure has none to show.
  if (error && !data) {
    return (
      <Flex data-testid="historical-answers-error">
        <InfoBox variant="error" title="Couldn't load the extracted questions and answers." />
      </Flex>
    );
  }

  const answers = [...(data?.historicalDdqAnswers ?? [])].sort(
    (a, b) => a.position - b.position,
  );

  if (answers.length === 0) {
    return (
      <EmptyState title="No extracted answers yet" data-testid="historical-answers-empty" />
    );
  }

  return (
    <Flex flexDirection="column" data-testid="historical-answers">
      {answers.map((entry) => (
        <QaEntryRow key={entry.id} entry={entry} />
      ))}
    </Flex>
  );
};
